import { LoadingIcon, Text } from "basis";

export const ProcessingPayment = () => (
  <div
    style={{
      width: "100%",
      height: "100%",
      position: "fixed",
      top: 0,
      right: 0,
      zIndex: 1,
      backgroundColor: "rgba(0,0,0,.7)",
      display: "grid",
      placeItems: "center",
    }}
  >
    <div style={{ textAlign: "center" }}>
      <LoadingIcon color="white" size="medium" />
      <Text role="alert" color="white">
        Processing payment...
      </Text>
    </div>
  </div>
);
